import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=4278b5b0&scoped=true"
import script from "./BookingDetail.vue?vue&type=script&lang=js"
export * from "./BookingDetail.vue?vue&type=script&lang=js"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=4278b5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278b5b0",
  null
  
)

export default component.exports